// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-line {
    width: 1px; /* Set the width to make it vertical */
    height: 100%; /* Full height of the container */
    background-color: #e0e0e0; /* Color of the line */
    border: none; /* Remove the default border */
    margin: 0; /* Remove default margins */
}

.custom-rectangular-button {
    border-radius: 0px !important;
}

.custom-height {
    height: '120px'; /* Adjust the height as needed */
}

/* <p className='designation_of_person mb-0 fst-italic '>{data.actor}</p> */
.dashboard-card-style {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
    margin-bottom: 5px;
    /* letter-spacing: -0.02em; */
}

.num-per {
    font-family: Inter;
    font-size: 52px;
    font-weight: 500;
    line-height: 57.2px;
    letter-spacing: -1%;
}

.overall-rate-grade {
    font-family: Inter;
    font-size: 2.75rem;
    font-weight: 500;
    line-height: 3.2rem;
    letter-spacing: -1%;
}
.overall-rate {
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.225rem;
    letter-spacing: -2%;
}
.card-dash {
    font-family: Inter;
    font-size: 3.25rem;
    font-weight: 500;
    line-height: 3.575rem;
    letter-spacing: -1%;
}
.card-dash-title {
    font-family: Inter;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 2rem;
}
.app-style {
    font-family: Inter;
    font-size: 32px;
    font-weight: 400;
    line-height: 44.8px;
    letter-spacing: -2%;
}
.text-style {
    font-family: Inter;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5rem;
    letter-spacing: -2%;
}
.text-style2 {
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.225rem;
    letter-spacing: -2%;
}
.text-style3 {
    font-family: Inter;
    font-size: 2.25rem;
    font-weight: 500;
    line-height: 2.475rem;
    letter-spacing: -1%;
}
/* .main-div:hover {
    background-color: red;
} */
/* .card-container:hover {
    background-color: red;
} */

.card-container.card:hover .card-footer {
    background-color: #323e4a !important;
}
.card-con:hover {
    border: 1px solid #bfc7ce !important;
}

.card-container:hover .card-footer p {
    color: #ffffff !important;
}
.card-arr:hover {
    color: #323e4a !important;
}
.grade-style {
    font-family: Inter;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.65rem;
    letter-spacing: -1%;
}
.rate-style1 {
    font-family: Inter;
    font-size: 0.88rem;
    font-weight: 400;
    line-height: 1.225rem;
    letter-spacing: -2%;
}
.text-style4 {
    font-family: Inter;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.65rem;
    letter-spacing: -1%;
}
.text-style5 {
    font-family: Inter;
    font-size: 0.8rem;
    font-weight: 400;
    line-height: 1.225rem;
    letter-spacing: -2%;
}

.style51 p {
    color: rgba(50, 62, 74, 0.8) !important;
}
.card-footer .d-flex {
    margin: 0;
    padding: 0;
}

.card-footer p {
    margin: 0;
    padding: 0;
    line-height: 1; /* Adjust this if necessary */
}
.px-custom {
    padding-left: 4rem !important; /* Increase as needed */
    padding-right: 4rem !important; /* Increase as needed */
}
.arr_icon {
    position: relative;
    width: 20.5px;
    height: 20.5px;
    margin-right: 16px;
    color: #969c9f !important;
}
.label-style {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
}
/* .progressLabel span.label-style:after {
    position: absolute;
    content: '';
    left: -1px;
    bottom: calc(-100% - 20px);
    height: calc(100% + 20px);
    width: 1px;
    background: #0f0303;
} */

.static-background-style {
    flex: 1 1 25%;
    border-left: 2px solid #e9e9e9;
    background-color: #ffffff;
}
.static-background {
    flex: 1 1 25%;
    border-left: 2px solid #e9e9e9;
}
`, "",{"version":3,"sources":["webpack://./src/features/modules/MenuScreensModule/Plot.css"],"names":[],"mappings":"AAAA;IACI,UAAU,EAAE,sCAAsC;IAClD,YAAY,EAAE,iCAAiC;IAC/C,yBAAyB,EAAE,sBAAsB;IACjD,YAAY,EAAE,8BAA8B;IAC5C,SAAS,EAAE,2BAA2B;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe,EAAE,gCAAgC;AACrD;;AAEA,2EAA2E;AAC3E;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;;GAEG;AACH;;GAEG;;AAEH;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;AACA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,cAAc,EAAE,6BAA6B;AACjD;AACA;IACI,6BAA6B,EAAE,uBAAuB;IACtD,8BAA8B,EAAE,uBAAuB;AAC3D;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;;;;;;;GAQG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,8BAA8B;AAClC","sourcesContent":[".vertical-line {\n    width: 1px; /* Set the width to make it vertical */\n    height: 100%; /* Full height of the container */\n    background-color: #e0e0e0; /* Color of the line */\n    border: none; /* Remove the default border */\n    margin: 0; /* Remove default margins */\n}\n\n.custom-rectangular-button {\n    border-radius: 0px !important;\n}\n\n.custom-height {\n    height: '120px'; /* Adjust the height as needed */\n}\n\n/* <p className='designation_of_person mb-0 fst-italic '>{data.actor}</p> */\n.dashboard-card-style {\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22.4px;\n    margin-bottom: 5px;\n    /* letter-spacing: -0.02em; */\n}\n\n.num-per {\n    font-family: Inter;\n    font-size: 52px;\n    font-weight: 500;\n    line-height: 57.2px;\n    letter-spacing: -1%;\n}\n\n.overall-rate-grade {\n    font-family: Inter;\n    font-size: 2.75rem;\n    font-weight: 500;\n    line-height: 3.2rem;\n    letter-spacing: -1%;\n}\n.overall-rate {\n    font-family: Inter;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.225rem;\n    letter-spacing: -2%;\n}\n.card-dash {\n    font-family: Inter;\n    font-size: 3.25rem;\n    font-weight: 500;\n    line-height: 3.575rem;\n    letter-spacing: -1%;\n}\n.card-dash-title {\n    font-family: Inter;\n    font-size: 1.5rem;\n    font-weight: 500;\n    line-height: 2rem;\n}\n.app-style {\n    font-family: Inter;\n    font-size: 32px;\n    font-weight: 400;\n    line-height: 44.8px;\n    letter-spacing: -2%;\n}\n.text-style {\n    font-family: Inter;\n    font-size: 1.25rem;\n    font-weight: 500;\n    line-height: 1.5rem;\n    letter-spacing: -2%;\n}\n.text-style2 {\n    font-family: Inter;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.225rem;\n    letter-spacing: -2%;\n}\n.text-style3 {\n    font-family: Inter;\n    font-size: 2.25rem;\n    font-weight: 500;\n    line-height: 2.475rem;\n    letter-spacing: -1%;\n}\n/* .main-div:hover {\n    background-color: red;\n} */\n/* .card-container:hover {\n    background-color: red;\n} */\n\n.card-container.card:hover .card-footer {\n    background-color: #323e4a !important;\n}\n.card-con:hover {\n    border: 1px solid #bfc7ce !important;\n}\n\n.card-container:hover .card-footer p {\n    color: #ffffff !important;\n}\n.card-arr:hover {\n    color: #323e4a !important;\n}\n.grade-style {\n    font-family: Inter;\n    font-size: 1.5rem;\n    font-weight: 500;\n    line-height: 1.65rem;\n    letter-spacing: -1%;\n}\n.rate-style1 {\n    font-family: Inter;\n    font-size: 0.88rem;\n    font-weight: 400;\n    line-height: 1.225rem;\n    letter-spacing: -2%;\n}\n.text-style4 {\n    font-family: Inter;\n    font-size: 1.5rem;\n    font-weight: 500;\n    line-height: 1.65rem;\n    letter-spacing: -1%;\n}\n.text-style5 {\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-weight: 400;\n    line-height: 1.225rem;\n    letter-spacing: -2%;\n}\n\n.style51 p {\n    color: rgba(50, 62, 74, 0.8) !important;\n}\n.card-footer .d-flex {\n    margin: 0;\n    padding: 0;\n}\n\n.card-footer p {\n    margin: 0;\n    padding: 0;\n    line-height: 1; /* Adjust this if necessary */\n}\n.px-custom {\n    padding-left: 4rem !important; /* Increase as needed */\n    padding-right: 4rem !important; /* Increase as needed */\n}\n.arr_icon {\n    position: relative;\n    width: 20.5px;\n    height: 20.5px;\n    margin-right: 16px;\n    color: #969c9f !important;\n}\n.label-style {\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22.4px;\n}\n/* .progressLabel span.label-style:after {\n    position: absolute;\n    content: '';\n    left: -1px;\n    bottom: calc(-100% - 20px);\n    height: calc(100% + 20px);\n    width: 1px;\n    background: #0f0303;\n} */\n\n.static-background-style {\n    flex: 1 1 25%;\n    border-left: 2px solid #e9e9e9;\n    background-color: #ffffff;\n}\n.static-background {\n    flex: 1 1 25%;\n    border-left: 2px solid #e9e9e9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
